import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  standalone: true,
})
export class ModalComponent {
  @Input() title: string = 'Modal Heading';
  @Input() content: string = 'Modal content goes here.';
  @Input() show: boolean = false;
  @Input() closeButtonLabel: string = 'Close';
  @Input() confirm = true;
  @Input() confirmButtonLabel: string = 'Save Changes';
  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<void>();

  closeModal() {
    this.onClose.emit();
  }

  confirmAction() {
    this.onConfirm.emit();
  }
}
